import Vue from 'vue'
import VueRouter from 'vue-router'
import { sendMsg } from '@/plugins/msg'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/nav'
  },
  {
    path: '/nav',
    component: () => import('@/views/Nav.vue')
  },
  {
    path: '/news',
    name: 'NewsList',
    meta: { title: '新闻' },
    component: () => import('@/views/News.vue')
  },
  {
    path: '/news/details',
    name: 'NewsDetails',
    meta: { title: '新闻详情' },
    component: () => import('@/views/NewsDetails.vue')
  },
  {
    path: '/announcement',
    name: 'AnnouncementList',
    meta: { title: '公告' },
    component: () => import('@/views/Announcement.vue')
  },
  {
    path: '/announcement/details',
    name: 'AnnouncementDetails',
    meta: { title: '公告详情' },
    component: () => import('@/views/AnnouncementDetails.vue')
  },
  {
    path: '/report',
    name: 'Report',
    meta: { title: '研报' },
    component: () => import('@/views/Report.vue')
  },
  {
    path: '/report/details',
    name: 'ReportDetails',
    meta: { title: '研报详情' },
    component: () => import('@/views/ReportDetails.vue')
  },
  {
    path: '/warrants',
    name: 'Warrants',
    meta: { title: '轮证' },
    component: () => import('@/views/Warrants.vue')
  },
  {
    path: '/warrants/details',
    name: 'WarrantsDetails',
    meta: { title: '轮证' },
    component: () => import('@/views/WarrantsDetails.vue')
  },
  {
    path: '/pdf',
    name: 'Pdf',
    component: () => import('@/views/Pdf.vue')
  },
  {
    path: '/f10',
    name: 'F10',
    component: () => import('@/views/F10.vue')
  },
  {
    path: '/f10/behavior',
    name: 'Behavior',
    component: () => import('@/views/F10Behavior.vue')
  },
  {
    path: '/f10/company',
    name: 'Company',
    component: () => import('@/views/F10Company.vue')
  },
  {
    path: '/f10/manager',
    name: 'Manager',
    component: () => import('@/views/F10Manager.vue')
  },
  {
    path: '/f10/shareholders',
    name: 'Shareholders',
    component: () => import('@/views/F10Shareholder.vue')
  },
  {
    path: '/f10/statements',
    name: 'Statements',
    component: () => import('@/views/F10Statements.vue')
  },
  {
    path: '/etf/constituent',
    name: 'FundConstituent',
    component: () => import('@/components/f10/etf/FundMember.vue')
  },
  {
    path: '/etf/result',
    name: 'FundResult',
    component: () => import('@/views/FundResultDetails.vue')
  },
  {
    path: '/etf/position',
    name: 'FundPosition',
    component: () => import('@/views/FundPositionDetails.vue')
  },
  {
    path: '/etf/size',
    name: 'FundSize',
    component: () => import('@/views/FundSizeDetails.vue')
  },
  {
    path: '/etf/dividends',
    name: 'FundDividends',
    component: () => import('@/views/FundDividends.vue')
  },
  {
    path: '/ipo',
    name: 'IPO',
    meta: { title: '新股' },
    component: () => import('@/views/IPO.vue')
  },
  {
    path: '/bidask',
    name: 'BidAsk',
    meta: { title: '盘口' },
    component: () => import('@/views/BidAsk.vue')
  },
  {
    path: '/bidask/broker',
    name: 'Broker',
    meta: { title: '经纪商持股详情' },
    component: () => import('@/views/BidAskBroker.vue')
  },
  {
    path: '/bidask/brokers',
    name: 'Brokers',
    meta: { title: '经纪商持股比例' },
    component: () => import('@/views/BidAskBrokers.vue')
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  next()
  sendMsg({ event: 'setTitle', title: to.meta.title ?? '' })
  if (
    !to.query.replace &&
    !['/bidask', '/news', '/announcement', '/report', '/f10', '/warrants'].includes(to.path) &&
    from.path !== '/'
  ) {
    sendMsg({ event: 'routerChange', fullPath: to.fullPath })
  } else next()
})

export default router
